import React from 'react';

const Head = () => (
  <thead>
    <tr>
      <th>Hidden categories</th>
      <th>{' '}</th>
    </tr>
  </thead>
);

Head.propTypes = {

};

export default Head;
